<app-user-dashboard>

  <div class="view-container">
    <div class="view-header view-separator pt-0 gap-2">
      <div class="view-container-title w-12">
        <h1 class="view-main-title">{{'AssignStock.AssignOrderTitle' | translate}}</h1>
      </div>
    </div>

    <div class="view-body-container">
      <div class="container-abstract mt-3" *ngIf="detail && importOrderDetailInfo">
        <div class="flex-column p-lat">
          <span style="font-size: small; padding-bottom:.5em">{{orderType}} order N {{padWithLeadingZeros(detail.importOrderSequence)}}</span>
          <div class="flex-row p-bottom">
            <div class="container-icon">
              <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="importOrderDetailInfo.importOrderDetail.varietyUrlIcon.length<1">
                no_photography
              </span>
              <img [src]="getImageUrl(importOrderDetailInfo.importOrderDetail.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 65px; height: auto;" alt="" *ngIf="importOrderDetailInfo.importOrderDetail.varietyUrlIcon.length>0"/>
            </div>
            <div class="flex-column justify-center">
              <span style="text-transform: uppercase; font-size: medium; font-weight: bold; line-height:1.1em">{{detail | speciesName}}</span>
              <span style="text-transform: uppercase; font-size: medium; line-height:1.1em">{{detail.varietyName}}</span>
            </div>
          </div>
        </div>
        <div class="flex-column p-lat p-top">
          <span style="color: #8c2b87; font-size: small;"><strong>{{orderType}} order detail N</strong> {{padWithLeadingZeros(detail.sequence)}}</span>
          <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ExporterLabel' | translate}}:</strong> <span class="pd-left">{{importOrderDetailInfo.importOrderDetail.exporterCompanyName ? importOrderDetailInfo.importOrderDetail.exporterCompanyName : "(No data)" }}</span></span>
          <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ImporterLabel' | translate}}:</strong> <span class="pd-left">{{importOrderDetailInfo.importOrderDetail.importerCompanyName ? importOrderDetailInfo.importOrderDetail.importerCompanyName : "(No data)" }}</span></span>
        </div>
        <div class="flex-column p-lat p-top">
          <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ContainerLabel' | translate}}:</strong> <span class="pd-left">{{importOrderDetailInfo.containerNumber ? importOrderDetailInfo.containerNumber : "(No data)" }}</span></span>
          <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETALabel' | translate}}:</strong> <span class="pd-left">{{importOrderDetailInfo.eta ? (importOrderDetailInfo.eta | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
          <span style="color: #8c2b87; font-size: small;"><strong>{{'UserPages.UserPurchaseOrders.AbstractOrder.ETDLabel' | translate}}:</strong> <span class="pd-left">{{importOrderDetailInfo.etd ? (importOrderDetailInfo.etd | date: 'dd-MM-yyyy') : "(No data)" }}</span></span>
        </div>
        <div class="flex-row p-lat">
          <span class="material-symbols-outlined" style="color: #8c2b87">pallet</span>
          <span style="margin-left: 10px;">{{detail.palletQuantity}}</span>
        </div>
        <div class="flex-row p-lat">
          <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 0">
            <img [flag]="detail.countryFromCode " height="40px" alt=""/>
            <div class="flex flex-column" style="margin-left: 10px;">
              <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
              <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
              <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.portFromName}}</span>
            </div>
          </div>

          <div class="flex justify-content-start align-items-center"  *ngIf="detail.transportType === 1">
            <img [flag]="detail.countryFromCode " height="40px" alt=""/>
            <div class="flex flex-column" style="margin-left: 10px;">
              <span style="font-weight: bolder; font-size: small;">{{detail.countryFromName}}</span>
              <!-- <span style="font-size: smaller;" *ngIf="!detail.portFromName">{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.OriginPortText' | translate }} (?)</span> -->
              <span style="font-size: smaller;" *ngIf="detail.portFromName">{{detail.fromAirport?.name}}</span>
            </div>
          </div>
        </div>

        <div class="flex flex-column justify-content-center">
          <div class="flex justify-content-center">
            <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 0">directions_boat</span>
            <span class="material-symbols-outlined" style="color: #6da043;"  *ngIf="detail.transportType === 1">flight</span>
            <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
          </div>
          <div *ngIf="importOrderInfo?.delivery?.ship" class="flex justify-content-center">
            <span class="text-center" style="font-size: small;">{{ importOrderInfo?.delivery?.ship }}</span>
          </div>
        </div>

        <div class="flex-row p-lat">
          <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 0">
            <img [flag]="detail.countryToCode" height="40px" alt=""/>
            <div class="flex flex-column" style="margin-left: 10px;">
              <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
              <span style="font-size: smaller;">{{detail.portToName}}</span>
            </div>
          </div>

          <div class="flex justify-content-start align-items-center" *ngIf="detail.transportType === 1" >
            <img [flag]="detail.countryToCode" height="40px" alt=""/>
            <div class="flex flex-column" style="margin-left: 10px;">
              <span style="font-weight: bolder; font-size: small; ">{{detail.countryToName}}</span>
              <span style="font-size: smaller;">{{detail.destinationAirport?.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="orderDetailGuid">
        <app-assign-stock
          #assignStockComponent
          [isOrderLoad]="true"
          [orderDetailGuid]="orderDetailGuid"
          (onAssignStock)="AfterAssignOrder()"/>
      </div>
    </div>
  </div>
</app-user-dashboard>

